import React from 'react';
var PaymentDetailsSection = function PaymentDetailsSection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payment-details-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-10 offset-md-1"
  }, children)))));
};
export default PaymentDetailsSection;